export const BOOKING_FIELDS = [
    {
        label: 'Billed Distance',
        value: 'distanceBreakUp.billedDistance',
    },
    {
        label: 'BillingMethod',
        value: 'billingMethod',
    },
    {
        label: 'Business Order Amount',
        value: 'priceBreakUp.businessOrderAmount',
    },
    {
        label: 'Booking Numeric Id',
        value: 'bookingNumericId',
    },
    {
        label: 'Business Name',
        value: 'businessName',
    },
    {
        label: 'Car Name',
        value: 'carName',
    },
    {
        label: 'Cook Time',
        value: 'cookTime',
    },
    {
        label: 'Country',
        value: 'country',
    },
    {
        label: 'Currency',
        value: 'currency',
    },
    {
        label: 'Customer Mobile',
        value: 'customerMobile',
    },
    {
        label: 'Customer Name',
        value: 'customerName',
    },
    {
        label: 'Delivery City',
        value: 'deliveryCity',
    },
    {
        label: 'Delivery Provider',
        value: 'deliveryProvider',
    },
    {
        label: 'Exact Distance',
        value: 'distanceBreakUp.exactDistance',
    },
    {
        label: 'Extra Distance',
        value: 'distanceBreakUp.extraDistance',
    },
    {
        label: 'Notifications',
        value: 'smrSentVia',
    },
    {
        label: 'Origin',
        value: 'origin',
    },
    {
        label: 'Order Amount',
        value: 'orderAmount',
    },
    {
        label: 'Payment Method',
        value: 'paymentMethod',
    },
    {
        label: 'Provider Fee',
        value: 'priceBreakUp.providerFee',
    },
    {
        label: 'Restart By Business',
        value: 'counters.restartByBusiness',
    },
    {
        label: 'Restart By Business With Penalty',
        value: 'counters.restartByBusinessWithPenalty',
    },
    {
        label: 'Status',
        value: 'statusText',
    },
    {
        label: 'Service Amount',
        value: 'ServiceAmount',
    },
    {
        label: 'Real Distance',
        value: 'distanceBreakUp.realDistance',
    },
    {
        label: 'Requires Proof Of Delivery',
        value: 'requiresProofOfDelivery',
    },
    {
        label: 'Used Google Address',
        value: 'usedGoogleAddress',
    },
];

export const BOOKING_VARIABLES = [
    {
        _id: 'distanceBreakUp.billedDistance',
        name: 'Billed Distance',
        value: 'distanceBreakUp.billedDistance',
    },
    {
        _id: 'priceBreakUp.businessOrderAmount',
        name: 'Business Order Amount',
        value: 'priceBreakUp.businessOrderAmount',
    },
    {
        _id: 'deliveryProvider',
        name: 'Delivery Provider',
        value: 'deliveryProvider',
    },
    {
        _id: 'distanceBreakUp.exactDistance',
        name: 'Exact Distance',
        value: 'distanceBreakUp.exactDistance',
    },
    {
        _id: 'distanceBreakUp.extraDistance',
        name: 'Extra Distance',
        value: 'distanceBreakUp.extraDistance',
    },
    {
        _id: 'priceBreakUp.providerFee',
        name: 'Provider Fee',
        value: 'priceBreakUp.providerFee',
    },
    {
        _id: 'country',
        name: 'Country',
        value: 'country',
    },
    {
        _id: 'orderAmount',
        name: 'Order Amount',
        value: 'orderAmount',
    },
    {
        _id: 'paymentMethod',
        name: 'Payment Method',
        value: 'paymentMethod',
    },
    {
        _id: 'counters.restartByBusiness',
        name: 'Restart By Business',
        value: 'counters.restartByBusiness',
    },
    {
        _id: 'counters.restartByBusinessWithPenalty',
        name: 'Restart By Business With Penalty',
        value: 'counters.restartByBusinessWithPenalty',
    },
    {
        _id: 'priceBreakUp.restartPenaltyFee',
        name: 'Restart Penalty Fee',
        value: 'priceBreakUp.restartPenaltyFee',
    },
];
